import React, { useState } from 'react';
import PageHero from '../components/PageHero';
import CTABanner from '../components/CTABanner';

const cats = ['All','MERN Stack','Java','Python','Flutter','Digital Marketing','Cyber Security'];

const projects = [
  { title:'ShopEase E-Commerce', cat:'MERN Stack', img:'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=700&auto=format&fit=crop&q=70', desc:'Full-featured platform with real-time inventory, multi-vendor support, and payments. Handles 10k+ daily orders.', tech:['React','Node.js','MongoDB','Stripe'], result:'140% Sales Growth', client:'ShopEase India' },
  { title:'BankCore Microservices', cat:'Java', img:'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=700&auto=format&fit=crop&q=70', desc:'Enterprise banking platform with 15+ microservices handling loans, deposits, and fraud detection for 500k+ customers.', tech:['Spring Boot','Kafka','PostgreSQL','Docker'], result:'99.99% Uptime', client:'FinTechPro' },
  { title:'AgroAI Crop Intelligence', cat:'Python', img:'https://images.unsplash.com/photo-1625246333195-78d9c38ad449?w=700&auto=format&fit=crop&q=70', desc:'ML platform analyzing soil, weather, and satellite data to provide personalized recommendations for farmers.', tech:['Python','TensorFlow','Django','AWS'], result:'35% Yield Improvement', client:'AgriTech Solutions' },
  { title:'LogiTrack Delivery App', cat:'Flutter', img:'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=700&auto=format&fit=crop&q=70', desc:'Real-time logistics tracking app with live GPS, route optimization, driver management, and notifications.', tech:['Flutter','Firebase','Google Maps','Node.js'], result:'50k Downloads', client:'LogiTrack Pvt Ltd' },
  { title:'BrandStar SEO Campaign', cat:'Digital Marketing', img:'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=700&auto=format&fit=crop&q=70', desc:'Comprehensive SEO + content campaign that tripled organic traffic and doubled leads in 6 months.', tech:['SEO','Content','Google Ads','Analytics'], result:'3x Organic Traffic', client:'BrandStar Agency' },
  { title:'SecureBank VAPT Audit', cat:'Cyber Security', img:'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=700&auto=format&fit=crop&q=70', desc:'Complete VAPT for a fintech company — discovered and remediated 47 critical vulnerabilities.', tech:['Burp Suite','Metasploit','Nessus','OWASP'], result:'47 Vulnerabilities Fixed', client:'SecureBank Corp' },
  { title:'HealthPlus Telemedicine', cat:'MERN Stack', img:'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=700&auto=format&fit=crop&q=70', desc:'HIPAA-compliant telemedicine platform with video consultations, e-prescriptions and insurance billing.', tech:['React','Node.js','WebRTC','MongoDB'], result:'200k+ Consultations', client:'HealthPlus' },
  { title:'EduTech LMS Platform', cat:'Java', img:'https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=700&auto=format&fit=crop&q=70', desc:'LMS supporting 100k+ students with live classes, assessments, certifications, and progress tracking.', tech:['Spring Boot','React','MySQL','AWS'], result:'100k+ Students', client:'EduTech Academy' },
  { title:'FoodieGo Delivery App', cat:'Flutter', img:'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=700&auto=format&fit=crop&q=70', desc:'Food delivery app with multi-restaurant ordering, real-time tracking, loyalty rewards, and AI recommendations.', tech:['Flutter','Dart','Firebase','Stripe'], result:'4.8★ App Rating', client:'FoodieGo Startup' },
];

const Portfolio = () => {
  const [filter, setFilter] = useState('All');
  const filtered = filter==='All' ? projects : projects.filter(p=>p.cat===filter);

  return (
    <main>
      <PageHero title="Our" highlight="Portfolio" subtitle="A curated selection of projects delivered across industries — real solutions, measurable results." breadcrumb="Portfolio" />

      <section className="section-pad" style={{ background:'var(--bg)' }}>
        <div className="container">
          {/* Filter row */}
          <div className="d-flex flex-wrap gap-4 mb-5" style={{ borderBottom:'1px solid var(--border)', paddingBottom:20 }}>
            {cats.map(c => (
              <button key={c} onClick={()=>setFilter(c)}
                className={`filter-tab ${filter===c?'active':''}`}>
                {c}
              </button>
            ))}
          </div>

          {/* Grid */}
          <div className="row g-4">
            {filtered.map((p,i) => (
              <div key={i} className="col-lg-4 col-md-6">
                <div className="warm-card" style={{ borderRadius:0 }}>
                  <div style={{ overflow:'hidden', height:220 }}>
                    <img src={p.img} alt={p.title} className="warm-card-img" style={{ height:220 }} />
                  </div>
                  <div style={{ padding:'24px 22px 28px' }}>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
                      <span style={{ fontFamily:'var(--font-body)', fontSize:'0.62rem', letterSpacing:'0.22em', textTransform:'uppercase', color:'var(--tan)' }}>{p.cat}</span>
                      <span style={{ color:'var(--tan2)', fontSize:'0.78rem' }}>{p.result}</span>
                    </div>
                    <h4 style={{ fontFamily:'var(--font-disp)', fontSize:'1.35rem', fontWeight:400, color:'var(--cream2)', marginBottom:10 }}>{p.title}</h4>
                    <p style={{ color:'var(--muted)', fontSize:'0.82rem', lineHeight:1.8, marginBottom:16, fontWeight:300 }}>{p.desc}</p>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                      <div>{p.tech.slice(0,3).map(t=><span key={t} className="tech-pill">{t}</span>)}</div>
                      <span style={{ color:'var(--muted)', fontSize:'0.75rem' }}>{p.client}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats */}
      <section style={{
        backgroundImage:`url('https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=1800&auto=format&fit=crop&q=50')`,
        backgroundSize:'cover', backgroundPosition:'center', position:'relative' }}>
        <div style={{ position:'absolute', inset:0, background:'rgba(28,21,16,0.9)' }} />
        <div className="container position-relative section-pad" style={{ zIndex:1 }}>
          <div className="row g-0" style={{ border:'1px solid var(--border)' }}>
            {[['250+','Projects Delivered'],['$50M+','Client Revenue Generated'],['98%','On-Time Delivery'],['4.9/5','Average Rating']].map(([n,l],i) => (
              <div key={i} className="col-6 col-md-3 text-center" style={{ padding:'48px 20px', borderRight:i<3?'1px solid var(--border)':'none' }}>
                <div className="stat-num">{n}</div>
                <div className="stat-label mt-2">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </main>
  );
};

export default Portfolio;
